export default "__VITE_ASSET__DVYB5cdz__"